import Component from 'inferno-component';

class ShareDeckModal extends Component {
  render() {
    const { sharedDeck, copiedDeck, closeHandler } = this.props;
    return (
      <div className="flashcard-modal">
        <div className="flashcard-modal--container">
          <div className="share-modal">
            {!sharedDeck && !copiedDeck ? (
              <div className="share-modal--content">
                <h2>
                  Invalid share link. Please request a new one and try again.
                </h2>
              </div>
            ) : null}
            {sharedDeck && (
              <div className="share-modal--content">
                <h2>share {sharedDeck.deckName} using this link</h2>
                <h3>
                  <a href={`/flashcards?shareId=${sharedDeck.deckShareId}`}>
                    https://manomano.io/flashcards?shareId={
                      sharedDeck.deckShareId
                    }
                  </a>
                </h3>
              </div>
            )}
            {copiedDeck && (
              <div className="share-modal--content">
                <h2>
                  <span className="success-icon">&#10003; </span>
                  {copiedDeck.deckName} has been added to your account
                </h2>
              </div>
            )}
            <div className="share-button">
              <button className="button" onClick={closeHandler}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShareDeckModal;



// WEBPACK FOOTER //
// ./src/components/ShareDeckModal.js